import { FC, useEffect, useRef, useState, memo } from 'react';
import i18next from 'i18next';

import { useScrollHeader } from '~src/services/hooks/useScrollHeader';

import {
  HeaderContainer,
  HeaderInner,
  HeaderTitle,
  SubTitle,
  RightCol,
  ContentContainer,
} from './listPageHeader.sc';

interface Props {
  t: i18next.TFunction;
  titleTxt: string;
  subTitleTxt: string;
  className?: string;
}

const ListPageHeader: FC<Props> = memo(({ t, titleTxt, subTitleTxt, children, className }) => {
  const headerRef = useRef(null);
  const { smallHeader } = useScrollHeader(headerRef, 225);
  const [animateHeader, setAnimateHeader] = useState(false);

  useEffect(() => {
    if (smallHeader) {
      setAnimateHeader(true);
    }
  }, [smallHeader]);

  return (
    <HeaderContainer className={className} $smallHeader={smallHeader} ref={headerRef}>
      <ContentContainer>
        <HeaderInner $smallHeader={smallHeader}>
          <HeaderTitle className={smallHeader ? 'hl2' : 'hl1'} data-translation={titleTxt}>
            {t(titleTxt)}
          </HeaderTitle>
          {!smallHeader && (
            <SubTitle
              className="body_text"
              $animate={animateHeader && !smallHeader}
              data-translation={subTitleTxt}
            >
              {t(subTitleTxt)}
            </SubTitle>
          )}
        </HeaderInner>
        {children && <RightCol>{children}</RightCol>}
      </ContentContainer>
    </HeaderContainer>
  );
});

export default ListPageHeader;
